import { Component, Input, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  Dimensions,
  ImageCroppedEvent,
  ImageTransform,
} from '../../../shared/components/image-cropper/interfaces/image-cropper.interfaces';

@Component({
  templateUrl: './upload-modal.component.html',
  styleUrl: './upload-modal.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class UploadModalComponent {
  @Input() resizeToWidth: number = 256;
  @Input() aspectRatio: number = 1;
  @Input() cropperMinWidth: number = 128;
  @Input() isCreateProject: boolean = false;
  @Input() maintainAspectRatio: boolean = false;
  data: any = {};
  imageFile: any;
  imageChangedEvent: any = '';
  croppedImage: string = '';
  protected canvasRotation: number = 0;
  protected showCropper: boolean = false;
  protected containWithinAspectRatio: boolean = false;
  transform: ImageTransform = {};

  constructor(public activeModal: NgbActiveModal) {}

  public upload(): void {
    this.activeModal.close(this.data.image);
  }

  public imageCropped(event: ImageCroppedEvent): void {
    this.croppedImage = event.base64;
    this.data.image = this.croppedImage;
  }

  public imageLoaded(): void {
    this.showCropper = true;
  }

  public cropperReady(sourceImageDimensions: Dimensions): void {
    sourceImageDimensions.width = 1000;
    sourceImageDimensions.height = 1000;
  }
}
